import { render, staticRenderFns } from "./OperatnItalianIcon.vue?vue&type=template&id=2a725d66&"
import script from "./OperatnItalianIcon.vue?vue&type=script&lang=ts&"
export * from "./OperatnItalianIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports